import React, { useEffect, useState } from "react";
import OrderForm from "../OrdersForm/OrdersForm";
import {
  useCreateOrder,
  useDistricts,
  useLocationsByCustomer,
  useProvinces,
  useTimeSlots,
  useWards,
  useListCustomerByKeySearch,
} from "hooks";
import { MetaTags } from "react-meta-tags";
import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import { useTranslation } from "react-i18next";
import { Container } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { getInitCustomerParams } from "pages/CustomerManagement/utils";
import MessageModal from "../../../components/shared-components/MessageModal";

const initLocationParams = () => {
  return {
    shipping_type: "1",
    keywords: "",
  };
};

const initLocalitiesParams = () => {
  return {
    countryId: 1,
    type: 1,
    parent_code: "",
  };
};

const HCMOrderPage = props => {
  const { t } = useTranslation(["order"]);
  const navigate = useNavigate();

  const [provinceParams, setProvinceParams] = useState(initLocalitiesParams);
  const [districtParams, setDistrictParams] = useState(initLocalitiesParams);
  const [wardParams, setWardParams] = useState(initLocalitiesParams);
  // List Customer
  const [customerParams, setCustomerParams] = useState(getInitCustomerParams);
  const [locationParams, setLocationParams] = useState(initLocationParams);

  const [openPopup, setOpenPopup] = useState(false);
  const [orderCode, setOrderCode] = useState('');
  const [customerCode, setCustomerCode] = useState('');
  const [messagePopups, setMessagePopups] = useState([]);

  const { data: customers, refetch: listCustomer } = useListCustomerByKeySearch(
    {
      params: customerParams,
    }
  );

  const { data: timeSlot } = useTimeSlots({ params: {'filter[type][in]': [0, 1]} });

  const { data: provinces, refetch: refetchProvinces } =
    useProvinces(provinceParams);
  const { data: districts, refetch: refetchDistricts } =
    useDistricts(districtParams);
  const { data: wards, refetch: refetchWards } = useWards(wardParams);
  const { data: districtAll, refetch: getDistricts } = useDistricts({
    countryId: 1,
    type: 2,
    parent_code: "",
  });
  const { data: wardAll, refetch: getWards } = useWards({
    countryId: 1,
    type: 3,
    parent_code: "",
  });

  const { data: locationsCustomer, refetch: refetchLocationCustomer } =
    useLocationsByCustomer({
      customerId: locationParams?.customerId,
      params: locationParams,
    });

  const handleChangeCustomer = customerId => {
    setLocationParams(prev => ({
      ...prev,
      customerId: customerId,
    }));
  };

  const toggleModalNotify = () => {
    setOpenPopup(!openPopup);
    handleCancel();
  };

  const onSuccessCreateOrder = _data => {
    if (_data.shipping_type === 3 || customerCode === 'GSNEW') {
      setOrderCode(_data.order_code)
      const mes = [];
      if (_data.shipping_type === 3) {
        mes.push({
          value: t('message.note', {
            order_code: _data.order_code
          }),
          class: ''
        });
      }
      if (customerCode === 'GSNEW') {
        mes.push({
          value: t('message.note_create_GSNEW'),
          class: 'text-danger'
        })
      }
      setMessagePopups(mes)
      setOpenPopup(true);
    } else if (_data.shipping_type === 2) {
      const mes = [];
      mes.push({
        value: t('message.note_shipping_type'),
        class: ''
      });
      setMessagePopups(mes)
      setOpenPopup(true);
    } else {
      navigate("/manage-orders");
    }
  };
  const { mutate: createOrder, isLoading: isCreateOrder } = useCreateOrder(onSuccessCreateOrder);
  const handleCreateOrder = data => {
    setCustomerCode(data.customer_code);
    createOrder(data);
  };

  useEffect(() => {
    const { run } = customerParams;
    if (run) {
      listCustomer();
    }
  }, [customerParams, listCustomer]);

  useEffect(() => {
    const { customerId } = locationParams;
    if (customerId) {
      refetchLocationCustomer();
    }
  }, [locationParams, refetchLocationCustomer]);

  useEffect(() => {
    setCustomerParams(prev => ({
      ...prev,
      sizePerPage: 100,
      run: true,
      shipping_type: 1,
    }));
  }, []);

  useEffect(() => {
    refetchProvinces();
    getDistricts();
    getWards();
  }, []);

  useEffect(() => {
    if (provinceParams?.type === 1) refetchProvinces();
  }, [provinceParams, refetchProvinces]);

  useEffect(() => {
    if (districtParams?.type === 2) refetchDistricts();
  }, [districtParams, refetchDistricts]);

  useEffect(() => {
    if (wardParams?.type === 3) refetchWards();
  }, [wardParams, refetchWards]);

  const handleCancel = () => {
    navigate("/manage-orders");
  };
  const handleLocationKeywordsChange = value => {
    setLocationParams(prev => ({ ...prev, keywords: value }));
  };
  const handleCustomerKeywordsChange = value => {
    setCustomerParams(prev => ({ ...prev, keywords: value }));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MessageModal
            isOpen={openPopup}
            autoFocus={true}
            centered={true}
            toggle={toggleModalNotify}
            clickOutsideNotClose={true}
            type={'infor'}
            // message={t('message.note', {
            //   order_code: orderCode
            // })}
            messages={messagePopups}
        >
        </MessageModal>
        <MetaTags>
          <title>
            {t("title.create", {
              location: t("location.hcm"),
            })}
          </title>
        </MetaTags>
        <div className="container-fluid">
          <BreadcrumbWithLink
            title={t("title.create", {
              location: t("location.hcm"),
            })}
            breadcrumbItems={[
              { name: t("title.manager") },
              { name: t("title.list"), link: "/manage-orders" },
              { name: t("title.create") },
            ]}
          />
        </div>
        <Container fluid={true}>
          <OrderForm
            customers={customers?.items}
            timeSlots={timeSlot?.items}
            isHCMOrder
            locationsCustomer={locationsCustomer?.items}
            handleChangeCustomer={handleChangeCustomer}
            provinces={provinces}
            districts={districts}
            wards={wards}
            districtAll={districtAll}
            wardAll={wardAll}
            createOrder={handleCreateOrder}
            refetchLocationCustomer={refetchLocationCustomer}
            onChangeProvince={value => {
              setDistrictParams(prev => ({
                ...prev,
                type: 2,
                parent_code: value,
              }));
            }}
            onChangeDistrict={value => {
              setWardParams(prev => ({ ...prev, type: 3, parent_code: value }));
            }}
            onKeywordsChange={handleCustomerKeywordsChange}
            handleCancel={handleCancel}
            onLocationKeywordsChange={handleLocationKeywordsChange}
            isCreateOrder={isCreateOrder}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default HCMOrderPage;
